/**
 * sz-animations.js — Shared IntersectionObserver for scroll reveals.
 * Adds .is-visible to [data-sz-reveal], [data-sz-stagger], [data-sz-scale].
 * <1.5KB. Loaded with defer. Re-initializes on shopify:section:load.
 */
(function () {
  var SELECTORS = '[data-sz-reveal],[data-sz-stagger]';

  function init() {
    var elements = document.querySelectorAll(SELECTORS);
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });

    elements.forEach(function (el) {
      if (!el.classList.contains('is-visible')) {
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
